import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContainerStyled = styled(Container)`
  height: 100%;
  flex-grow: 1;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
